import { render, staticRenderFns } from "./userEducation.vue?vue&type=template&id=d4fbcb3e&scoped=true&"
import script from "./userEducation.vue?vue&type=script&lang=js&"
export * from "./userEducation.vue?vue&type=script&lang=js&"
import style0 from "./userEducation.vue?vue&type=style&index=0&id=d4fbcb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fbcb3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4fbcb3e')) {
      api.createRecord('d4fbcb3e', component.options)
    } else {
      api.reload('d4fbcb3e', component.options)
    }
    module.hot.accept("./userEducation.vue?vue&type=template&id=d4fbcb3e&scoped=true&", function () {
      api.rerender('d4fbcb3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/userEducation.vue"
export default component.exports